import { Button, Checkbox, IconButton, Menu, MenuItem, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, useTheme } from "@mui/material";
import { CustomTextField } from "../../layouts/themes";
import { AFSClassification, PPTClassification, PPTRuleRequest, PPTRules, PPTRulesCategorisation, PPTRulesDescription, PPTRulesDescriptionCategorisationRequest, PPTRulesDescriptionRequest, Reconciliation, SocialAccountMapping, UpdatePPTRulesDescriptionCategorisationRequest } from "../../helpers/interfaces";
import React, { useEffect } from "react";

//import { alertError } from "../../helpers/utils";


import { Edit, MoreHoriz, MoreVert } from "@mui/icons-material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import { createPPTRules, createPPTRulesCategorisation, createPPTRulesDescription, createPPTRulesFromPreviousYear, deletePPTRulesCategorisation, deletePPTRulesDescription, getAllPPTRules, getAllPPTRulesCategorisation, getAllPPTRulesDescription, updatePPTRules, updatePPTRulesCategorisation, updatePPTRulesDescription, } from "../../apiServices/PPTRulesApi";
import { FormEditMode, ReportType } from "../../helpers/constants";
import CreateEditOpexRules from "./CreateEditOpexRules";
import styled from "@emotion/styled";


import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { enqueueSnackbar } from "notistack";




const MySwal = withReactContent(Swal);

interface Props {
    setYear: React.Dispatch<React.SetStateAction<string>>
    year: string
    reportType: ReportType
    pptClassification: PPTClassification[]
    reconciliation: Reconciliation[]
    afsClassification: AFSClassification[]
    copyPPTRules: boolean
    socialAccountMapping: SocialAccountMapping[]
    setCopyPPTRules: React.Dispatch<React.SetStateAction<boolean>>
}
function OpexRules({ reportType, copyPPTRules, socialAccountMapping, setCopyPPTRules, setYear, year, pptClassification, reconciliation, afsClassification }: Props) {
    const theme = useTheme();
    const [pptRules, setPPTRules] = React.useState<PPTRules[]>([])
    const [pptDescriptions, setPPTDescriptions] = React.useState<PPTRulesDescription[]>([])
    const [pptCategorizations, setPPTCategorizations] = React.useState<PPTRulesCategorisation[]>([])
    let counter = pptDescriptions.length; // Initial value
    let categoryCounter = pptCategorizations.length
    const [newDescriptionName, setNewDescriptionName] = React.useState("");
    const [newCategorizationName, setNewCategorizationName] = React.useState("");
    const [categorizationNameToEdit, setCategorizationNameToEdit] = React.useState("");
    const [descriptionNameToEdit, setDescriptionNameToEdit] = React.useState("");
    const [opexRuleToEdit, setOpexRuleToEdit] = React.useState("");
    const [openOpexRulesForm, setOpenOpexRulesForm] = React.useState(false);
    const [opexRuleEditMode, setOpexRuleEditMode] = React.useState(FormEditMode.CREATE);
    const [previousYear, setPreviousYear] = React.useState("");
    const [currentYear, setCurrentYear] = React.useState("");


    const StyledTableRow = styled(TableRow)({
        '&:nth-of-type(even)': {
            backgroundColor: theme.palette.action.hover,
            size: 'small',
        },
        border: '1px solid #cbcbcb !important',


    });
    const StyledTableCell = styled(TableCell)({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.mode === 'dark' ? theme.palette.action.hover : theme.palette.action.hover,
            color: theme.palette.error.main,
            fontSize: 11,
            size: 'small',
            fontWeight: 550,
            border: '1px solid #cbcbcb !important',



        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 11,
            size: 'small',
            padding: 7,
            border: '1px solid #cbcbcb !important',



        },
    });
    const truncateWords = (text: string, wordLimit: number) => {
        const words = text.split(' ');
        return words.length > wordLimit
            ? words.slice(0, wordLimit).join(' ') + '...'
            : text;
    };
    useEffect(() => {
        getAllPPTRules(reportType, year).then(pptRules => setPPTRules(pptRules.sort((a, b) => a.pptRulesDescription.order - b.pptRulesDescription.order)))
        getAllPPTRulesCategorisation(reportType, year).then(category => setPPTCategorizations(category.sort((a, b) => a.order - b.order)))
        getAllPPTRulesDescription(reportType, year).then(desc => setPPTDescriptions(desc.sort((a, b) => a.order - b.order)))
    }, [reportType, year])

    const handleEdit = (desc: PPTRulesDescription) => {
        setOpexRuleToEdit(desc.id)
        setOpexRuleEditMode(FormEditMode.EDIT);
        setOpenOpexRulesForm(true);
    }

    const addDescription = async () => {
        // if (pptDescriptions.find(desc => desc.name.toUpperCase() === newDescriptionName.toUpperCase()) != null) {
        //     MySwal.fire(alertError(newDescriptionName + " exists already"));
        //     return
        // }
        let data: PPTRulesDescription = await createPPTRulesDescription(newDescriptionName, counter + 1, reportType, year)
        setPPTDescriptions([...pptDescriptions, data])
        let pptRulesDescriptionCategorisationRequests: PPTRulesDescriptionCategorisationRequest[] = []
        pptCategorizations.forEach(pptCategorizations => {
            pptRulesDescriptionCategorisationRequests.push({
                pptRulesCategorisationId: pptCategorizations.id,
                isManualInput: false,
                isNegateValue: false,
                amount: 0,
                pptClassificationIds: [],
                reconciliationIds: [],
                afsClassificationIds: [],
                socialAccountMappingIds: []
            })
        })
        let pptRulesDescriptionRequest: PPTRulesDescriptionRequest = {
            pptRulesDescriptionId: data.id,
            pptRulesDescriptionCategorisationRequests: pptRulesDescriptionCategorisationRequests
        }
        let pptRuleRequest: PPTRuleRequest = {
            year: year,
            reportType: reportType,
            pptRulesDescriptionRequests: [pptRulesDescriptionRequest]
        }

        let pptRule: PPTRules[] = await createPPTRules(pptRuleRequest)

        setPPTRules([...pptRules, ...pptRule])
        setNewDescriptionName('')

    }

    const updateDescription = async () => {
        // Find the existing description to keep its current order
        const existingDescription = pptDescriptions.find(
            (description) => description.id === descriptionNameToEdit
        );

        if (!existingDescription) return;

        const updatedDescription: PPTRulesDescription = await updatePPTRulesDescription(
            descriptionNameToEdit,
            newDescriptionName,
            existingDescription.order // ✅ preserve current order

        );

        // Update state with the modified description
        setPPTDescriptions(prevDescriptions =>
            prevDescriptions.map(desc =>
                desc.id === descriptionNameToEdit ? { ...desc, name: updatedDescription.name } : desc
            )
        );

        setNewDescriptionName('')
        setDescriptionNameToEdit("")
    }


    const addCategorization = async () => {
        // if (pptDescriptions.find(desc => desc.name.toUpperCase() === newCategorizationName.toUpperCase()) != null) {
        //     MySwal.fire(alertError(newCategorizationName + " exists already"));
        //     return
        // }
        let data: PPTRulesCategorisation = await createPPTRulesCategorisation(newCategorizationName, categoryCounter + 1, reportType, year)
        setPPTCategorizations([...pptCategorizations, data])
        let pptRulesDescriptionCategorisationRequests: UpdatePPTRulesDescriptionCategorisationRequest[] = []
        pptRules.forEach(pptRule => {
            pptRulesDescriptionCategorisationRequests.push({
                pptRulesCategorisationId: data.id,
                isManualInput: false,
                isNegateValue: false,
                pptClassificationIds: [],
                reconciliationIds: [],
                afsClassificationIds: [],
                pptRulesId: pptRule.id,
                pptRulesDescriptionCategorisationId: null,
                socialAccountMappingIds: []
            })
        })

        let pptRule: PPTRules[] = await updatePPTRules(pptRulesDescriptionCategorisationRequests)
        pptRules.map(p => {
            let __pptRule = pptRule.find(a => a.id === p.id)!
            p.pptRulesDescriptionCategorisations = __pptRule?.pptRulesDescriptionCategorisations
            return p
        })
        setNewCategorizationName('')
    }

    const updateCategorization = async () => {
        // Find the existing categorization to keep its current order
        const existingCategorization = pptCategorizations.find(
            (category) => category.id === categorizationNameToEdit
        );

        if (!existingCategorization) return;

        const updatedCategorization: PPTRulesCategorisation = await updatePPTRulesCategorisation(
            categorizationNameToEdit,
            newCategorizationName,
            existingCategorization.order // ✅ preserve current order
        );

        // Update state with the modified categorization
        setPPTCategorizations((prevCategorizations) =>
            prevCategorizations.map((category) =>
                category.id === categorizationNameToEdit
                    ? { ...category, name: updatedCategorization.name }
                    : category
            )
        );

        setNewCategorizationName('');
        setCategorizationNameToEdit('');
    };

    const handleDeleteDescription = async (
        id: string,
        name: string,
        popupState: { close: () => void }
    ) => {
        popupState.close();

        const confirmDelete = await MySwal.fire({
            title: `Delete "${name}"?`,
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it",
            cancelButtonText: "Cancel",
        });

        if (!confirmDelete.isConfirmed) return;

        try {
            await deletePPTRulesDescription(id);

            // ✅ Remove the deleted category from state
            setPPTDescriptions((prev) => prev.filter((desc) => desc.id !== id));
            // ✅ 2. Remove all PPT rules that belong to the deleted description
            setPPTRules((prev) =>
                prev.filter((rule) => rule.pptRulesDescriptionId !== id)
            );
            // ✅ Notify user
            enqueueSnackbar(`"${name}" deleted successfully.`, { variant: "success" });
        } catch (error) {
            enqueueSnackbar(`Failed to delete "${name}".`, { variant: "error" });
        }
    };
    const handleDeleteCategorization = async (
        id: string,
        name: string,
        popupState: { close: () => void }
    ) => {
        popupState.close();

        const confirmDelete = await MySwal.fire({
            title: `Delete "${name}"?`,
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it",
            cancelButtonText: "Cancel",
        });

        if (!confirmDelete.isConfirmed) return;

        try {
            await deletePPTRulesCategorisation(id);

            // ✅ Remove the deleted category from state
            setPPTCategorizations((prev) => prev.filter((cat) => cat.id !== id));

            // ✅ Notify user
            enqueueSnackbar(`"${name}" deleted successfully.`, { variant: "success" });
        } catch (error) {
            enqueueSnackbar(`Failed to delete "${name}".`, { variant: "error" });
        }
    };
    const handleClosePopupState = (popupState: { close: () => void }) => {
        popupState.close();
    };
    const handleCopyPPTRules = async () => {
        createPPTRulesFromPreviousYear(previousYear, currentYear, reportType).then(res => {
            setYear(currentYear)
        })
    }
    return (
        <div>

            {(pptDescriptions === null || pptDescriptions.length === 0) && (pptCategorizations === null || pptCategorizations.length === 0) &&
                <div>
                    <Checkbox color="secondary" checked={copyPPTRules} onChange={(e, checked) => setCopyPPTRules(checked)} />&nbsp;
                    <label style={{ fontSize: 13 }} className='title-label'>Do you want to create the reconciliation rules based on the Rules from previous years?</label>

                </div>
            }
            {copyPPTRules &&
                <div className='flex '>
                    <span style={{ width: '30%' }}>
                        <CustomTextField size="small" id="outlined-basic" placeholder="Previous Year" variant="outlined" sx={{ width: '100%' }}
                            onChange={(e) => setPreviousYear(e.target.value)} value={previousYear} />
                    </span>  &nbsp; &nbsp;
                    <span style={{ width: '30%' }}>
                        <CustomTextField size="small" id="outlined-basic" placeholder="Year" variant="outlined" sx={{ width: '100%' }}
                            onChange={(e) => setCurrentYear(e.target.value)} value={currentYear} /> &nbsp;
                    </span> &nbsp; &nbsp;

                    <div style={{ width: '20%' }}>
                        <Button variant="contained" color="success" onClick={handleCopyPPTRules}>Copy Reconciliation Rules</Button>
                    </div>

                </div>
            }
            {!copyPPTRules &&
                <div className='flex mb-6'>
                    <div style={{ width: '50%' }}>
                        <CustomTextField size="small" id="outlined-basic" placeholder="Add Disallowed costs" variant="outlined" sx={{ width: '80%' }}
                            onChange={(e) => setNewDescriptionName(e.target.value)} value={newDescriptionName} /> &nbsp;
                        <Button style={{ width: '16%' }} variant="contained" disabled={newDescriptionName === ''} color="info" onClick={descriptionNameToEdit === '' ? addDescription : updateDescription} >{descriptionNameToEdit === '' ? 'Add' : 'Update'}</Button>
                    </div>&nbsp;&nbsp;
                    <div style={{ width: '50%' }}>
                        <CustomTextField size="small" id="outlined-basic" placeholder="Add Categorization" variant="outlined" sx={{ width: '80%' }}
                            onChange={(e) => setNewCategorizationName(e.target.value)} value={newCategorizationName} /> &nbsp;
                        <Button style={{ width: '16%' }} variant="contained" color="info" disabled={newCategorizationName === ''} onClick={categorizationNameToEdit === '' ? addCategorization : updateCategorization} >{categorizationNameToEdit === '' ? 'Add' : 'Update'}</Button>
                    </div>

                </div>
            }


            <div className="">
                <TableContainer className="table table-bordered table-sm table-responsive" sx={{ maxHeight: '56vh', overflowX: 'scroll', overflowY: 'auto', border: '1px solid rgba(224, 224, 224, 1)', '&::-webkit-scrollbar': { width: '6px', height: '6px', }, '&::-webkit-scrollbar-track': { backgroundColor: 'rgba(0,0,0,0.1)', }, '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(0,0,0,0.3)', borderRadius: '4px', }, '&::-webkit-scrollbar-thumb:hover': { backgroundColor: 'rgba(0,0,0,0.5)', } }}    >
                    <Table size="small" sx={{ borderCollapse: 'collapse', }}  >
                        <TableHead>
                            <StyledTableRow >
                                <StyledTableCell className="border" style={{ position: "sticky", left: 0, zIndex: 1, background: `${theme.palette.error.contrastText}`, fontSize: '12px', minWidth: '80px' }}> Action</StyledTableCell>
                                <StyledTableCell className="border" style={{ fontSize: '12px', minWidth: '200px', position: "sticky", left: 80, zIndex: 1, background: `${theme.palette.error.contrastText}`, }}> Description</StyledTableCell>

                                {pptCategorizations.map(e =>
                                    <StyledTableCell
                                        className="border"
                                        key={'btnDel' + e.name}
                                        style={{ fontSize: '12px', minWidth: '400px' }}
                                        title={e.name} // Tooltip showing full category name
                                    >
                                        <div className=' flex flex-row ' style={{ width: '100%' }}>
                                            <div className=' flex w-2/3 '
                                                style={{

                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    flex: 1,
                                                    marginRight: '4px',
                                                    padding: '2px'
                                                }}
                                            >
                                                {truncateWords(e.name, 5)}
                                            </div>

                                            <PopupState variant="popover" popupId="demo-popup-menu">
                                                {(popupState: any) => (
                                                    <React.Fragment>
                                                        <IconButton
                                                            color='inherit'
                                                            size="small"
                                                            sx={{
                                                                padding: '2px',
                                                                minWidth: '20px',
                                                                flexShrink: 0
                                                            }}
                                                            {...bindTrigger(popupState)}
                                                        >
                                                            <MoreVert fontSize="small" />
                                                        </IconButton>
                                                        <Menu {...bindMenu(popupState)}>
                                                            <MenuItem
                                                                key={'btnEdit' + e.id}
                                                                onClick={() => {
                                                                    setNewCategorizationName(e?.name);
                                                                    setCategorizationNameToEdit(e?.id);
                                                                    popupState.close();
                                                                }}
                                                            >
                                                                <Edit color='info' fontSize="small" />&nbsp; Edit Category
                                                            </MenuItem>

                                                            <MenuItem
                                                                key={'btnDelete' + e.id}
                                                                onClick={() => handleDeleteCategorization(e.id, e.name, popupState)}
                                                            >
                                                                🗑️ Delete Category
                                                            </MenuItem>
                                                        </Menu>
                                                    </React.Fragment>
                                                )}
                                            </PopupState>
                                        </div>
                                    </StyledTableCell>
                                )}
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {pptRules?.map((e, index) => {
                                let desc = pptDescriptions.find(d => d.id === e.pptRulesDescriptionId)!

                                return <StyledTableRow key={index}>
                                    <StyledTableCell
                                        style={{ border: '1px solid #cbcbcb !important', position: "sticky", left: 0, zIndex: 1, background: `${theme.palette.error.contrastText}`, fontSize: '12px', minWidth: '80px' }}
                                    >
                                        <PopupState variant="popover" popupId="demo-popup-menu">
                                            {(popupState) => (
                                                <React.Fragment>

                                                    <IconButton color='inherit' {...bindTrigger(popupState)}><MoreHoriz /></IconButton>

                                                    <Menu {...bindMenu(popupState)}>
                                                        <MenuItem key={'btnDescEdit' + desc?.id} onClick={() => { setNewDescriptionName(desc?.name); setDescriptionNameToEdit(desc?.id); handleClosePopupState(popupState) }}> <Edit color='info' />&nbsp; &nbsp;Edit Description Name</MenuItem>

                                                        <MenuItem key={'btnEdit' + desc?.id} onClick={() => { handleEdit(desc); handleClosePopupState(popupState) }} > <Edit color='info' />&nbsp; &nbsp;Edit Rule </MenuItem>
                                                        <MenuItem key={'btnEdit' + desc?.id} onClick={() => { handleDeleteDescription(desc.id, desc.name, popupState) }} > <Edit color='info' />&nbsp; &nbsp;Delete Description </MenuItem>

                                                    </Menu>
                                                </React.Fragment>
                                            )}
                                        </PopupState>
                                    </StyledTableCell>
                                    <StyledTableCell style={{ border: '1px solid #cbcbcb !important', position: "sticky", left: 80, zIndex: 1, background: `${theme.palette.error.contrastText}`, fontSize: '12px', minWidth: '200px' }}>
                                        {desc?.name}

                                    </StyledTableCell>

                                    {pptCategorizations.map(b => {
                                        let categ = pptRules.find(a => a.pptRulesDescriptionId === e.pptRulesDescriptionId)?.pptRulesDescriptionCategorisations.find(f => f.pptRulesCategorisationId === b.id)

                                        return <StyledTableCell
                                            key={b.id}
                                            sx={{
                                                border: '1px solid #cbcbcb !important',
                                                fontSize: '11px',
                                                width: '350px',
                                                minWidth: '350px',
                                                maxWidth: '350px',
                                                padding: '8px',
                                                verticalAlign: 'top'
                                            }}
                                        >

                                            {categ?.isManualInput ? <>Manual input
                                            </> : <>
                                                <>
                                                    {categ?.pptRulesClassifications?.length ? (
                                                        <>
                                                            <b>PPTClassification:</b>{' '}
                                                            {categ.pptRulesClassifications.map((c) => c.pptClassification?.name).join(', ')}
                                                        </>
                                                    ) : null}
                                                    <br />
                                                </>
                                                <>
                                                    {categ?.pptRulesAFSClassifications?.length ? (
                                                        <>
                                                            <b>AFSClassification:</b>{' '}
                                                            {categ.pptRulesAFSClassifications.map((c) => c.afsClassification?.name).join(', ')}
                                                        </>
                                                    ) : null}
                                                    <br />
                                                </>
                                                <>
                                                    {categ?.pptRulesSocialAccountMappings?.length ? (
                                                        <>
                                                            <b>SocialAccountMappings:</b>{' '}
                                                            {categ.pptRulesSocialAccountMappings.map((c) => c.socialAccountMapping?.name).join(', ')}
                                                        </>
                                                    ) : null}
                                                    <br />
                                                </>

                                                <>
                                                    {categ?.pptRulesReconciliations.length ? (
                                                        <>
                                                            <b>Reconciliation:</b>{' '}
                                                            {categ.pptRulesReconciliations.map(c => c.reconciliation?.name).join(', ')}
                                                        </>
                                                    ) : null}
                                                    <br />
                                                </>
                                                <>
                                                    {categ?.pptRulesReconciliations.length || categ?.pptRulesClassifications?.length ? (
                                                        <>
                                                            <b>Negative Value:</b>{' '}
                                                            {categ.isNegateValue ? 'Yes' : 'No'}
                                                        </>
                                                    ) : null}
                                                    <br />
                                                </>
                                            </>}
                                        </StyledTableCell>
                                    }
                                    )}

                                </StyledTableRow>

                            })}
                            {pptRules.length === 0 &&
                                <tr>
                                    <StyledTableCell colSpan={3}><p style={{ fontSize: '11px', textAlign: 'center' }}>No record available...</p></StyledTableCell>
                                </tr>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

            {openOpexRulesForm &&
                <CreateEditOpexRules socialAccountMapping={socialAccountMapping} year={year} reportType={reportType} reconciliation={reconciliation} pptClassification={pptClassification} afsClassification={afsClassification} setPPTRules={setPPTRules} pptRules={pptRules} openOpexRulesForm={openOpexRulesForm} setOpenOpexRulesForm={setOpenOpexRulesForm} setFormEditMode={setOpexRuleEditMode} opexRuleToEdit={opexRuleToEdit} opexRuleEditMode={opexRuleEditMode} pptCategorizations={pptCategorizations} />

            }
        </div>
    )
}
export default OpexRules